type Props = {
  size: number;
  color?: string;
};

const Laundry = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8334 1.5C20.6618 1.5 21.3334 2.17157 21.3334 3V21C21.3334 21.8284 20.6618 22.5 19.8334 22.5H4.83337C4.00495 22.5 3.33337 21.8284 3.33337 21V3C3.33337 2.17157 4.00495 1.5 4.83337 1.5H19.8334ZM4.83337 21H19.8334V3H4.83337V21ZM12.3334 7.5C15.6471 7.5 18.3334 10.1863 18.3334 13.5C18.3334 16.8137 15.6471 19.5 12.3334 19.5C9.01967 19.5 6.33337 16.8137 6.33337 13.5C6.33337 10.1863 9.01967 7.5 12.3334 7.5ZM15.8578 14.3496C15.0469 14.1713 13.9367 14.1663 12.7181 14.8936C11.1101 15.8535 9.59499 15.8587 8.48767 15.6152C8.43779 15.6043 8.38937 15.589 8.34119 15.5771C9.09176 17.0168 10.5975 18 12.3334 18C14.4309 18 16.1929 16.5649 16.6918 14.623C16.474 14.5271 16.191 14.4229 15.8578 14.3496ZM12.3334 9C9.84809 9 7.83337 11.0147 7.83337 13.5C7.83337 13.6067 7.83779 13.7125 7.84509 13.8174C8.07456 13.928 8.40571 14.0615 8.80994 14.1504C9.62082 14.3286 10.7311 14.3338 11.9496 13.6064C13.5577 12.6465 15.0727 12.6412 16.1801 12.8848C16.4091 12.9351 16.6196 12.9986 16.8109 13.0635C16.5913 10.7831 14.6713 9 12.3334 9ZM10.0834 6H6.33337V4.5H10.0834V6ZM16.0834 6H14.5834V4.5H16.0834V6ZM18.3334 6H16.8334V4.5H18.3334V6Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default Laundry;
